import { render } from "./DatesView.vue?vue&type=template&id=0bc09e42"
import script from "./DatesView.vue?vue&type=script&lang=js"
export * from "./DatesView.vue?vue&type=script&lang=js"

import exportComponent from "/home/kreativ-mobil.com/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__